import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { set } from 'lodash';

@Component({
  selector: 'app-virtual-scroll',
  templateUrl: './virtual-scroll.component.html',
  styleUrls: ['./virtual-scroll.component.scss']
})
export class VirtualScrollComponent implements OnInit {
  @Input() outputBody: any;
  @Input() parentDiv: any;
  searchOutputBody: string = '';
  paginatedJsonOutput = [];
  filteredValueOutputBody = [];
  constructor() { }
  ngOnInit() {
    this.initPaginatedJson();
    setTimeout(() => {
        const wrapper = document.querySelector("." + this.parentDiv);
        const mainScroll = document.querySelector("." + "virtual-scroll-container");

      if (!wrapper || !mainScroll) return;

      const wrapperHeight = wrapper.clientHeight;

      // Get offsetTop of .main-scroll relative to wrapper
      const offsetTop = (mainScroll as HTMLElement)?.offsetTop;

      const availableHeight = wrapperHeight - offsetTop;

      if (mainScroll) {
        (document.getElementsByClassName('virtual-viewport')[0] as HTMLElement).style.maxHeight = `${availableHeight - 100}px`;
        (document.getElementsByClassName('virtual-viewport')[0] as HTMLElement).style.overflowY = 'auto';
      }
    }, 1500)
  }
  initPaginatedJson() {
    let jsonStr = '';
    try {
      const dt = typeof(this.outputBody) == 'string' ? JSON.parse(this.outputBody) : this.outputBody;
      jsonStr = JSON.stringify(dt, null, 2);
    } catch (e) {
      jsonStr = String(this.outputBody);
    }
    const lines = jsonStr.split('\n');
    this.paginatedJsonOutput = lines; // Limiting to first 5000 lines for performance
    this.filteredValueOutputBody = lines.slice(0, 5000);
  }
  onSearch() {
    this.filteredValueOutputBody = [];
    for (let i = 0; i < this.paginatedJsonOutput.length; i++) {
      if (this.paginatedJsonOutput[i] && this.paginatedJsonOutput[i].toLowerCase().includes(this.searchOutputBody.toLowerCase())) {
        let startIndex = i;
        let endIndex = i;
        // loop backward to find '{'
        while (startIndex > 0 && !this.paginatedJsonOutput[startIndex].includes('{')) {
          startIndex--;
        }
        // loop forward to find '}'
        while (endIndex < this.paginatedJsonOutput.length && !this.paginatedJsonOutput[endIndex].includes('}')) {
          endIndex++;
        }
        // get the output
        this.filteredValueOutputBody.push(...this.paginatedJsonOutput.slice(startIndex, endIndex + 1));
      }
    }
  }
  onClear() {
    this.searchOutputBody = '';
    this.filteredValueOutputBody = this.paginatedJsonOutput;
  }
}
